export default __webpack_public_path__ + "static/media/pickles2.8ba05088.png";